import React from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom'
import App from '@/App'
import NotFound from '@/views/notFound'
import requireAll from '@/utils/requireAll'

const allRoutersMap = requireAll(require.context('@/routers/', false, process.env.NODE_ENV === 'development' ? /(?<!index)\.js$/ : /(?<!(index|demo))\.js$/))

export const allRouters = Object.keys(allRoutersMap).reduce((total, currKey, index) => {
  const currVal = allRoutersMap[currKey]
  return total.concat(currVal)
}, [])

// 注意：v6中不需要自定义RouteWithSubRoutes组件，改为直接返回Route配置
const renderRoute = (route) => {
  const { path, component: Component, children, ...otherProps } = route;
  // 渲染路由（v6用element属性，传递JSX元素）
  return (
    <Route
      key={path}
      path={path}
      {...otherProps}
      // element属性接收JSX元素，替代v5的render
      element={
        Component ? <Component childRoutes={children} /> : null
      }
    >
      {/* 渲染子路由（v6中子路由通过嵌套Route实现） */}
      {children && children.map(childRoute => renderRoute(childRoute))}
    </Route>
  );
};

const Routers = (props) => {
  return (
    <Router>
      <App>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          {
            allRouters.map((route, index) => {
              return renderRoute(route)
            })
          }
          <Route path="*" element={<NotFound />} />
      </Routes>
    </App>
    </Router >
  )
}

export default Routers